import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { WarningCircle, SignOut, ArrowsClockwise } from "@phosphor-icons/react";
import { money, fdate } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import RenewDialog from "@/components/RenewDialog";
import { Button } from "@/components/ui/button";

export default function LicenseExpired() {
  const { user, logout, refresh } = useAuth();
  const navigate = useNavigate();
  const lic = user?.license;
  const company = user?.company;
  const isAdmin = user?.role === "empresa_admin";
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="license-expired">
      <div className="max-w-md w-full bg-card border border-border rounded-lg p-8 text-center">
        <div className="w-14 h-14 rounded-lg bg-red-100 dark:bg-red-950 flex items-center justify-center mx-auto mb-4">
          <WarningCircle size={30} weight="fill" className="text-red-600 dark:text-red-400" />
        </div>
        <h1 className="text-2xl font-display font-bold mb-2">Licencia vencida</h1>
        <p className="text-sm text-muted-foreground mb-1">{company?.empresa}</p>
        {lic?.fecha_vencimiento && <p className="text-sm text-muted-foreground mb-4">Venció el {fdate(lic.fecha_vencimiento)}</p>}
        <p className="text-sm mb-6">El acceso está suspendido. Renueva la licencia anual de {money(lic?.precio || 2000)} para reactivarlo.</p>

        {isAdmin ? (
          <Button data-testid="expired-renew-btn" className="w-full rounded-lg gap-2 mb-3" onClick={() => setOpen(true)}>
            <ArrowsClockwise size={16} /> Renovar ahora
          </Button>
        ) : (
          <p className="text-sm text-amber-600 mb-3">Contacta al administrador de tu empresa para renovar la licencia.</p>
        )}
        <Button data-testid="expired-logout" variant="outline" className="w-full rounded-lg gap-2"
          onClick={async () => { await logout(); navigate("/login"); }}>
          <SignOut size={16} /> Cerrar sesión
        </Button>
      </div>

      <RenewDialog open={open} onOpenChange={setOpen} empresa={company?.empresa} precio={lic?.precio} onDone={refresh} />
    </div>
  );
}
